import { isObject, digestMessage, isValidSHA256String } from './modules/utils.js';
const AREA_CODES = [
    '420',
    '421',
    '49',
    '43',
    '36',
    '48',
    '39',
    '33',
    '44',
    '34',
    '385',
    '213',
    '376',
    '244',
    '1264',
    '1268',
    '54',
    '374',
    '297',
    '61',
    '994',
    '1242',
    '973',
    '880',
    '1246',
    '375',
    '32',
    '501',
    '229',
    '1441',
    '975',
    '591',
    '387',
    '267',
    '55',
    '673',
    '359',
    '226',
    '257',
    '855',
    '237',
    '1',
    '238',
    '1345',
    '236',
    '56',
    '86',
    '57',
    '269',
    '242',
    '682',
    '506',
    '53',
    '90392',
    '357',
    '45',
    '253',
    '1809',
    '1809',
    '593',
    '20',
    '503',
    '240',
    '291',
    '372',
    '251',
    '500',
    '298',
    '679',
    '358',
    '594',
    '689',
    '241',
    '220',
    '7880',
    '233',
    '350',
    '30',
    '299',
    '1473',
    '590',
    '671',
    '502',
    '224',
    '245',
    '592',
    '509',
    '504',
    '852',
    '354',
    '91',
    '62',
    '98',
    '964',
    '353',
    '972',
    '1876',
    '81',
    '962',
    '7',
    '254',
    '686',
    '850',
    '82',
    '965',
    '996',
    '856',
    '371',
    '961',
    '266',
    '231',
    '218',
    '417',
    '370',
    '352',
    '853',
    '389',
    '261',
    '265',
    '60',
    '960',
    '223',
    '356',
    '692',
    '596',
    '222',
    '269',
    '52',
    '691',
    '373',
    '377',
    '976',
    '1664',
    '212',
    '258',
    '95',
    '264',
    '674',
    '977',
    '31',
    '687',
    '64',
    '505',
    '227',
    '234',
    '683',
    '672',
    '670',
    '47',
    '968',
    '680',
    '507',
    '675',
    '595',
    '51',
    '63',
    '351',
    '1787',
    '974',
    '262',
    '40',
    '7',
    '250',
    '378',
    '239',
    '966',
    '221',
    '381',
    '248',
    '232',
    '65',
    '386',
    '677',
    '252',
    '27',
    '94',
    '290',
    '1869',
    '1758',
    '249',
    '597',
    '268',
    '46',
    '41',
    '963',
    '886',
    '7',
    '66',
    '228',
    '676',
    '1868',
    '216',
    '90',
    '7',
    '993',
    '1649',
    '688',
    '256',
    '380',
    '971',
    '598',
    '1',
    '7',
    '678',
    '379',
    '58',
    '84',
    '84',
    '84',
    '681',
    '969',
    '967',
    '260',
    '263',
];
/**
 * Unifies area code format and removes all non-digit characters
 */
export const _normalize = (phoneNumber) => {
    if (isObject(phoneNumber) || Array.isArray(phoneNumber)) {
        return null;
    }
    return String(phoneNumber)
        .trim()
        .replace(/^(0{1,2}|\+)/, '00')
        .replace(/\D/g, '');
};
/**
 * Checks if normalized number contains area code
 */
export const _includesAreaCode = (normalizedPhoneNumber) => normalizedPhoneNumber.substring(0, 2) === '00';
/**
 * Converts phone number into object where number and area code are separated
 */
export const _parse = (normalizedPhoneNumber) => {
    const parsed = {
        t1: '',
        t2: normalizedPhoneNumber,
    };
    if (_includesAreaCode(parsed.t2)) {
        for (const code of AREA_CODES) {
            const areaCode = `00${code}`;
            if (parsed.t2.startsWith(areaCode)) {
                parsed.t1 = code;
                parsed.t2 = parsed.t2.replace(new RegExp(`^${areaCode}`), '');
                break;
            }
        }
    }
    return parsed;
};
/**
 * Checks if value is valid hashed TID object
 */
export const isValidHashedTidObject = (phoneNumber) => {
    return (isObject(phoneNumber) &&
        typeof phoneNumber.t1 === 'string' &&
        (phoneNumber.t1 === '' || AREA_CODES.includes(phoneNumber.t1)) &&
        isValidSHA256String(phoneNumber.t2));
};
/**
 * Creates object that contains area code and hashed phone number
 */
export const createPhoneObject = (phoneNumber, digest = true) => {
    const normalizedValue = _normalize(phoneNumber);
    if (!normalizedValue) {
        return {};
    }
    // Convert to object where phone number and area code are separated
    const phoneObj = _parse(normalizedValue);
    // too short phone number - not valid
    if (phoneObj.t2.length < 4) {
        return {};
    }
    if (digest) {
        // hash phone number
        phoneObj.t2 = digestMessage(phoneObj.t2);
    }
    return phoneObj;
};
